import React from 'react'
import { Outlet } from 'react-router-dom'

import { ProtectedRoute } from '@hpanel/web-common/components/ProtectedRoute'

import { ClientLayout } from './ClientLayout'

/**
 * The single entry point for every authenticated tenant screen.
 *
 * Mirror of the admin `AdminShell`: authentication and chrome are properties
 * of being routed here, not something each page re-implements. `EmailV2` had
 * already drifted — it was reachable from the sidebar and rendered with no
 * `ClientLayout` at all — which is the recurrence that justifies moving the
 * wrapper out of the pages.
 *
 * No `requiredRole` here on purpose: admins legitimately view tenant screens
 * during impersonation, so the tenant plane gates on authentication only.
 */
export const ClientShell: React.FC = () => (
  <ProtectedRoute>
    <ClientLayout>
      <Outlet />
    </ClientLayout>
  </ProtectedRoute>
)
